import * as React from "react";
import styled from "styled-components";
import { TextFieldLabel, LabelProps } from "./TextField";

const StyledTextArea = styled.textarea`
  width: 100%;
`;

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea#Attributes
interface IProps extends LabelProps {
  value?: string;
  name?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  rows?: number;
  readOnly?: boolean;
  disabled?: boolean;
}

function TextArea({ label, required, valid, ...props }: IProps) {
  return (
    <>
      <TextFieldLabel label={label} required={required} valid={valid} />
      <StyledTextArea {...props} />
    </>
  );
}

export default TextArea;



// WEBPACK FOOTER //
// ./app/javascript/components/core/TextArea.tsx